const productFilter = (state = {value: ""}, {type, payload}) => {
  switch (type) {
    case  "SHOP_CHANGE":
      return {value: ""}
    case  "SHOP.CHANGE_PRODUCT_FILTER":
      return {value: payload.value}
    default:
      return state
  }
}

export default productFilter
